import { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './comfirmations.module.scss';
import { AppContext } from '../../../router/approuter';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import errorImg from '../../../assets/img/woman_scared.png';
import { decryptString } from '../../core/crypto';
import { acceptImprovementActions } from '../../api/talentClient';
import { appConfig } from '../../config/runtimeConfig';

export const Confirmations = () => {

    const appContext = useContext(AppContext);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState();

    const careersUrl = appConfig.careersLanding;

    useEffect(() => {
        // const jsonStringTest = '{"feedbackId": 0,"talentFirstName": ""}';
        // const jsonEncrypt = encryptString(jsonStringTest);
        // console.log('data ecnry', jsonEncrypt);
        // tA/5LlCN6tb1fABvsD/RTO8EfGKgKHQfZUUVKBljSXF1T13fNND17ladOL0/wc3CyJRoE+hXfZK3jtUrYdajjA== - {"feedbackId": 769,"talentFirstName": "Margarito"}
        // tA/5LlCN6tb1fABvsD/RTCt05O5H6/3tpfwXjFM5MbFD4ufjsBhHSagpS451PTGrGzBsmHd/CQAHx5uQfmS1lw== - {"feedbackId": 768,"talentFirstName": "Margarito"}
        // zzCZ9IxTVB698O05lx/9v2Ch1JQUmp75ckahw25VGukI1HvXF7tMJ9ViwKEMwlMR - {"feedbackId": 1,"talentFirstName": "Ismael"}
        // UJdxNx0mpKyecnQL4bqSQYm2H6kLqlbpKpFAASL8nXg - Sin feedbackId
        let data = searchParams.get('data');
        if ( data ) {
            data = data.replaceAll(' ', '+').replaceAll(/["]/g, '');
            const jsonData = JSON.parse(decryptString(data));
            // console.log('jsonData', jsonData);
            if ( jsonData.feedbackId ) {
                acceptImprovementActions(jsonData.feedbackId).then(({status, data}) => {
                    if ( status === 200 && data.code === 200 ) {
                        navigate(`/confirmation/success?talentFirstName=${jsonData.talentFirstName}`);
                    } else if ( data.msg ) {
                        setErrorMessage(data.msg)
                    } else {
                        setErrorMessage(true);
                    }
                }).catch(error => {
                    console.log('Error to accept improvements', error);
                    if ( error.response?.data?.msg ) {
                        setErrorMessage(error.response.data.msg);
                    } else {
                        setErrorMessage(error.message);
                    }
                })
            } else {
                setErrorMessage('Sin información de evaluación');
            }
        } else {
            setErrorMessage('Sin información de confirmación');
        }
    }, []);

    const renderNotConfirmation = () => errorMessage && (
        <div className={ styles.confirmations }>
            <div className={ styles.confirmations_container }>
                <span className={ `${styles.confirmations_title} ${styles.confirmations_title_secondary} ${styles.confirmations_text_middle}` }>Lo sentimos, la p&aacute;gina que buscas ya no est&aacute; disponible.</span>
                <div className={ styles.message }>
                    <span className={ `${styles.confirmations_text} ${styles.confirmations_text_middle} ${styles.confirmations_text_error}` }>Si consideras que esto es un error, por favor, ponte en contacto con tu <b>Reclutador o &aacute;rea de Recursos Humanos</b> para poder solucionarlo.</span>
                </div>
                <div className={ styles.message_img}>
                    { appContext.isDesktopOrLaptop && (<img src={ errorImg } alt="" />) }
                </div>
                <a className={ styles.button } href={ careersUrl }>Volver al inicio</a>
            </div>
        </div>
    )

    return (
        <div>
            <Header />
            { renderNotConfirmation() }
            { appContext.isDesktopOrLaptop && <Footer /> }
        </div>
    )
}
